import React, { FC, useState, useEffect } from 'react'
import styles from './ServicesModalContainer.module.scss'
import ServicesContent from '../molecules/ServicesContent'
import MoreLink from '../atoms/MoreLink'
import Widget from '../atoms/Widget'
import ModalCardContent from './ModalCardContent'
import { CardEntity } from '../../ducks/cards/types'
import classnames from 'classnames'

interface PropsType {
  card: CardEntity
  resetModal(): void
}

const ServicesModalContainer: FC<PropsType> = ({card, resetModal}) => {
  const [isClosing, setIsClosing] = useState(false)

  const closeModal = () => {
    setIsClosing(true)
    setTimeout(() => {
      resetModal()
    }, 500);
  }

  return (
    <div className= { classnames(styles.modalContainer, {[styles.closing]: isClosing}) }>
      <div className= { styles.modalContent }>
        <ModalCardContent card={card}/>
        <ServicesContent services={ card.services} />
        <div className={ styles.closeButton} onClick={() => closeModal() }>
          閉じる
        </div>
        <div className={ styles.buttonContainer }>
          <MoreLink card={card} />
          <div className={ styles.searchButton } onClick={() => closeModal() }>
            スワイプに戻る
          </div>
          <Widget />
        </div>
        <div className={ styles.credit}>
          Powered by <a href="https://affiliate.dmm.com/api/">FANZA Webサービス</a>
        </div>
      </div>
    </div>
  )
}

export default ServicesModalContainer
